import { ApiContext } from '../../types'
import { deserializeAudio } from '@/api_client/api/serializers/audio'
import { Audio } from '@/api_client/types/audios'
import { AuthHelper } from '@/api_client'

export default async function transcribeRemaining(
  { client, config }: ApiContext,
  audioId,
): Promise<any> {
  try {
    const bearerToken = AuthHelper.getAccessToken()

    const result = await client.audios.transcribeRemaining(
      bearerToken.toString(),
      audioId,
    )

    if (result.isSuccess()) {
      return deserializeAudio(result.success())
    } else {
      return {}
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
